export default __webpack_public_path__ + "static/media/img4.33d25813.jpg";